<button
  class="button-s-two"
  color="warn"
  extended
  mat-flat-button
  type="button"
  [disabled]="_isLoading || disabled"
  [ngClass]="{
    'ddc-gradient-standout': _isLightTheme || _isDarkTheme,
    'ddc-gradient-standout-paper': _isPaperTheme,
  }"
  (click)="onClick()"
>
  <mat-icon *ngIf="_icon">{{ _icon }}</mat-icon>
  {{ _label }}
</button>
